module.exports = "/packs/media/images/icons/specialrules-d5d2db2ef2b9768a41a63c56b2d2133b.png";